export const UserRequestSteps = [
  {
    target: ".j_req_audit",
    content: "View the audit trail to track all activities related to user security requests.",
    placement: "bottom",
  },

  {
    target: ".j_srch",
    content: "Search requests by user name, ID, or other attributes to quickly find records.",
    placement: "bottom",
  },
  {
    target: ".j_fil",
    content: "Click here to apply filters and refine the list of security requests.",
    placement: "bottom",
  },
  {
    target: ".j_req_upload",
    content: "Upload an Excel sheet to import or update user security requests in bulk.",
    placement: "bottom",
  },
  {
    target: ".j_req_create",
    content: "Click here to manually create a new user security request.",
    placement: "bottom",
  },
  {
    target: ".j_tbl1_nam",
    content: "This column displays the name of the user associated with the request.",
    placement: "top",
  },
  {
    target: ".j_tbl2_sta",
    content: "This column shows the current request status (e.g., Requested, Rejected, Approved).",
    placement: "top",
  },
  {
    target: ".j_tbl3_req",
    content: "This column indicates who submitted the request and when it was created.",
    placement: "top",
  },
  {
    target: ".j_tbl4_rev",
    content: "This column shows who reviewed the request and the review date.",
    placement: "top",
  },
  {
    target: ".j_tbl5_col5",
    content: "Use these action buttons to view request details or delete the request.",
    placement: "left",
  },
];
